import { useSynchronousStorage } from './useSynchronousStorage';

export const useLocalStorage = useSynchronousStorage(() => window.localStorage);
